// extracted by mini-css-extract-plugin
export default {"desktopLayout":"T2OoH5","mobileLayout":"MwASYI"};